/// <amd-module name="DistributedTaskUI/Logs/StepComponent" />
import * as React from "react";

import { Button } from "VSSUI/Button";
import { FocusZone, FocusZoneDirection } from "OfficeFabric/FocusZone";
import { Tooltip } from "VSSUI/TooltipEx";
import { getId } from "VSS/Core/Util/Object";
import { css } from "VSSUI/Util";

import { IVssIconProps, VssIcon } from "VSSUI/VssIcon";
import { Status, IStatusProps, StatusSize } from "VSSUI/Status";

import "VSS/LoaderPlugins/Css!DistributedTaskUI/Logs/StepComponent";

export interface IStepStatus {
    status: string;
    className?: string;
}

export interface IInfoProps {
    tooltipContent: string | undefined;
    iconName: string;
    iconAriaLabel: string;
}

export interface IStepStatusProps {
    statusProps: IStatusProps;
    className?: string;
}


export interface IStepComponentProps {
    title: string;
    /**
     * @deprecated use statusProps
     */
    iconProps?: IVssIconProps;
    statusProps?: IStepStatusProps;
    cssClass?: string;
    isTitleClickable?: boolean;
    onActionClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    hasSepartor?: boolean;
    /**
     * @deprecated Use stepStatuses
     */
    stepStatus?: IStepStatus;
    stepStatuses?: IStepStatus[];
    infoProps?: IInfoProps;
    rightSection?: JSX.Element;
    tooltipContent?: string;
    ariaLabel?: string;
    ariaDescription?: string;
    buttonAriaDescription?: string;
    uniqueKey?: string;
}

export class StepComponent extends React.Component<IStepComponentProps, {}> {

    public render(): React.ReactNode {
        const disabled = !this.props.isTitleClickable;
        let className: string = "step-log-component-action-button";
        let disabledClassName: string = "";
        if (disabled) {
            disabledClassName = "disabled-step";
            className = css(className, disabledClassName);
        }

        const describedById: string = getId("step-log-view-description");
        return (
            <FocusZone direction={FocusZoneDirection.horizontal} isCircularNavigation={false}>
                <div className="step-log-view-container" aria-label={this.props.ariaLabel} aria-describedby={describedById}>
                    <div id={describedById} className="hidden">{this.props.ariaDescription}</div>
                    <div className={css(this.props.cssClass, "step-log-content", "flex")}>
                        <div className="step-log-component-left-section flex">
                            {
                                this.props.statusProps &&
                                <Status {...this.props.statusProps.statusProps} className={css("left-section-step-status-icon", "left-section-step-status", this.props.statusProps.className)} size={StatusSize.m} />
                            }
                            {
                                !this.props.statusProps && this.props.iconProps &&
                                <VssIcon
                                    className={css(this.props.iconProps.className, "left-section-step-status-icon")}
                                    iconName={this.props.iconProps.iconName}
                                    iconType={this.props.iconProps.iconType}
                                    title={this.props.iconProps.title}
                                    style={this.props.iconProps.style}
                                />
                            }
                            <span className={css("left-step-tooltip-host", disabledClassName)}>
                                <Button
                                    subtle={true}
                                    className={className}
                                    disabled={disabled}
                                    onClick={this._onClick}
                                    ariaLabel={this.props.buttonAriaDescription}
                                    tooltipProps={{ showOnFocus: true, text: this.props.tooltipContent }}>
                                    {this._onRenderText()}
                                </Button>
                            </span>
                            {this._getInfoButton()}
                        </div>
                        <div className="step-log-component-right-section flex">
                            {this.props.rightSection}
                        </div>
                    </div>
                </div>
            </FocusZone>
        );
    }

    private _getInfoButton() {
        return this.props.infoProps && this.props.infoProps.tooltipContent && (
            <div>
                <span key={"step-info-tooltip"} className="dt-tooltip-pre-line">
                    <Button
                        subtle={true}
                        className="step-info-button"
                        iconProps={{ iconName: this.props.infoProps.iconName }}
                        ariaLabel={this.props.infoProps.iconAriaLabel}
                        tooltipProps={{ showOnFocus: true, text: this.props.infoProps.tooltipContent }}>
                    </Button>
                </span>
            </div>);
    }

    private _onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        if (this.props.onActionClick) {
            this.props.onActionClick(event);
        }
    }

    private _onRenderText = (): JSX.Element => {
        const stepStatuses = this.props.stepStatuses || (this.props.stepStatus ? [this.props.stepStatus] : []);
        const uniqueKey = this.props.uniqueKey || getId("step-name-key");
        return (

            <div className="left-section-step-name flex" key={uniqueKey}>
                {<div className="left-section-step-title ellipsis-overflow">{this.props.title}</div>}
                {this.props.hasSepartor && <div className="left-section-step-status-separator">&middot;</div>}
                {stepStatuses.length > 0 &&
                    stepStatuses.map((stepStatus, index) => {
                        return <div key={index} className={css("left-section-step-status", "log-task-state", "log-task-state-common-color", stepStatus.className)}>
                            {stepStatus.status}
                        </div>;
                    })
                }
            </div>
        );
    }
}
